<template>
  <form v-on:submit.prevent="AssingPatientInBed">
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Ingresar datos del paciente</p>
        <button type="button" class="delete" @click="$emit('close')" />
      </header>
      <section class="modal-card-body">
        <b-loading
          :is-full-page="false"
          v-model="isLoadingFullModal"
          :can-cancel="true"
        ></b-loading>
        <b-steps
          v-model="activeStep"
          :animated="true"
          :rounded="true"
          :has-navigation="true"
          :label-position="'bottom'"
          :mobile-mode="'minimalist'"
        >
        <!-- //Cuando se solicite que se agregue el paciente cambiar esto sacando el v-if -->
          <b-step-item step="1" label="Busqueda de Paciente" :clickable="true" v-if="false"> 
            <b-field label="Buscar Paciente..." grouped>
              <b-input
                placeholder="Buscar por Rut ..."
                type="search"
                v-model="rutSearch"
                v-on:keypress.native="isValidCharacter($event)"
                expanded                
              ></b-input>
              <p class="control">
                <b-button
                  class="button is-primary"
                  @click="searchPatient"
                  :disabled="!rutSearch"
                  >Buscar</b-button
                >
              </p>
            </b-field>
            <div class="card">
              <div class="card-content">
                <b-loading
                  :is-full-page="false"
                  v-model="isLoading"
                  :can-cancel="true"
                ></b-loading>
                <b-field label="Nombre">
                  <b-input
                    v-model="patient.name"
                    :disabled="disabledPatientData"
                    required
                  ></b-input>
                </b-field>
                <b-field label="Apellido Paterno">
                  <b-input
                    v-model="patient.pather_lastname"
                    :disabled="disabledPatientData"
                    required
                  ></b-input>
                </b-field>
                <b-field label="Apellido Materno">
                  <b-input
                    v-model="patient.mother_lastname"
                    :disabled="disabledPatientData"
                    required
                  ></b-input>
                </b-field>
                <b-field label="Rut/Pasaporte">
                  <b-input
                    v-model="patient.document"
                    :disabled="disabledPatientData"
                    required
                  ></b-input>
                </b-field>
                <b-field label="Edad">
                  <b-input
                    v-model="patient.age"
                    :disabled="disabledPatientData"
                    required
                  ></b-input>
                </b-field>
              </div>
            </div>
          </b-step-item>

          <b-step-item step="2" label="Datos del Diagnóstico" :clickable="true">
            <b-field label="Resultado PCR">
              <b-select
                v-model="covid19"
                placeholder="Resultado PCR"
                expanded
                required
              >
                <option value="positivo">Positivo</option>
                <option value="sospecha">Sospecha</option>
                <option value="negativo">Negativo</option>
                <option value="no aplica">No aplica</option>
              </b-select>
            </b-field>
            <b-field label="Paciente con ventilador" v-if="bed.ventilator == 'si'">
              <b-select
                v-model="ventilator_used"
                placeholder="¿La cama necesita ventilador?"
                expanded
                required
              >
                <option value="si">Si</option>
                <option value="no">No</option>
              </b-select>
            </b-field>
            <b-field label="Diagnóstico" v-if="false">
              <b-input v-model="diagnostic" type="textarea"></b-input>
            </b-field>
          </b-step-item>
        </b-steps>
      </section>
      <footer class="modal-card-foot">
        <button class="button" type="button" @click="$emit('close')">
          Cerrar
        </button>
        <button
          class="button is-primary"
          type="submit"          
        >
          Guardar
        </button>
      </footer>
    </div>
  </form>
</template>
<script>
import { GetBed, PutBed } from "../../services/beds";
import { PatientFindByRut, PostPatient } from "../../services/patient";
import { PostBedHistory } from "../../services/bedHistory";
import { eventBus } from "../../main";

export default {
  props: ["bed"],
  data() {
    return {
      activeStep: 0,
      patient_id: null,
      rutSearch: null,
      patient: {
        document: "",
        name: "",
        pather_lastname: "",
        mother_lastname: "",
        age: "",
      },
      covid19: "negativo",
      ventilator_used: "no",
      diagnostic: "",
      disabledPatientData: true,
      isLoading: false,
      isLoadingFullModal: false,
    };
  },
  methods: {
    async createPatient() {
      let patientData = await PostPatient(this.$http, this.patient);
      return patientData;
    },
    async searchPatient() {
      try {
        if(this.validaRut(this.rutSearch)){
          this.isLoading = true;
          let response = await PatientFindByRut(this.$http, this.rutSearch);
          if (response.length !== 0) {
            this.patient_id = response[0].id;
            this.patient = response[0];
            this.disabledPatientData = true;
            this.$buefy.toast.open({
              message: "Paciente encontrado",
              type: "is-success",
            });
          } else {
            this.patient_id = null;
            this.patient = {
              document: this.rutSearch,
              name: "",
              pather_lastname: "",
              mother_lastname: "",
              age: "",
            };
            this.disabledPatientData = false;
            this.$buefy.toast.open({
              message: "Paciente no encontrado, favor de ingresar los datos",
              type: "is-warning",
            });
          }
          this.isLoading = false;
        }else{
          this.$buefy.toast.open({
          message: "Rut no válido",
          type: "is-danger",
        });
        }
      } catch (err) {
        this.$buefy.toast.open({
          message: "Error al buscar paciente",
          type: "is-danger",
        });
      }
    },
    async AssingPatientInBed() {
      try {
          this.isLoadingFullModal = true;
          let responseBed = await GetBed(this.$http, this.bed.id);
          if (!this.patient_id) {
            // let data = await this.createPatient();
            // this.patient_id = data.id;
          }
          let dataBed = {
            ...responseBed,
            covid19: this.covid19,
            ventilator_used: this.ventilator_used,
            patient_id: 1,  //Cuando se solicite que se agregue el paciente cambiar esto por this.patient_id
          };
          await PutBed(this.$http, this.bed.id, dataBed);
          let dataBedHistory = {
            bed_id: this.bed.id,
            ...responseBed,
            covid19: this.covid19,
            ventilator_used: this.ventilator_used,
            user_id: JSON.parse(window.localStorage.getItem("user")).id,
            patient_id: null, //Cuando se solicite que se agregue el paciente cambiar esto por this.patient_id
          };
          await PostBedHistory(this.$http, dataBedHistory);
          this.isLoadingFullModal = false;
          eventBus.$emit("loadBedList");
          this.$parent.close();
          this.$buefy.toast.open({
            message: "Paciente asignado a cama",
            type: "is-success",
          });
        
      } catch (err) {
        this.$buefy.toast.open({
          message: "Error al asignar al paciente",
          type: "is-danger",
        });
      }
    },
    isValidCharacter(evt) {
      const keysAllowed = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "k", "-"];
      const keyPressed = evt.key;
      if (!keysAllowed.includes(keyPressed)) {
        evt.preventDefault();
      }
    },
    validaRut: function (rutCompleto) {
      if (!/^[0-9]+[-|‐]{1}[0-9kK]{1}$/.test(rutCompleto)) return false;
      var tmp = rutCompleto.split("-");
      var digv = tmp[1];
      var rut = tmp[0];
      if (digv == "K") digv = "k";      
      return this.dv(rut) == digv;
    },
    dv: function (T) {
      var M = 0,
        S = 1;
      for (; T; T = Math.floor(T / 10))
        S = (S + (T % 10) * (9 - (M++ % 6))) % 11;
      return S ? S - 1 : "k";
    },
  },
};
</script>